import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useNeighborhoods } from "@/hooks/useNeighborhoods";
import type { NeighborhoodWithCity } from "@/types/neighborhood";

interface NeighborhoodFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export const NeighborhoodFilter = ({ value, onChange }: NeighborhoodFilterProps) => {
  const { data: neighborhoods } = useNeighborhoods();

  return (
    <Select value={value || "all"} onValueChange={onChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Neighborhoods" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Neighborhoods</SelectItem>
        {(neighborhoods as NeighborhoodWithCity[] | undefined)?.map((neighborhood) => (
          <SelectItem key={neighborhood.id} value={neighborhood.name}>
            {neighborhood.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
